(async function () {
  const addScript = () => {
    const node = document.getElementById("selecty-script");
    if (node) {
      node.type = "text/javascript";
      // remove and insert node in the same place when main thread is idle
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => {
          node.parentNode.replaceChild(node, node);
        });
      } else {
        node.parentNode.replaceChild(node, node);
      }
    }
  }

  const wasRedirected = localStorage.getItem("sel-autodetect") === "1";

  if (!wasRedirected) {
    response = await fetch(
      "/browsing_context_suggestions.json?source=geolocation_recommendation&country[enabled]=true&currency[enabled]=true&language[enabled]=true",
      {
        method: "GET",
        mode: "cors",
        cache: "default",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      }
    );

    const { suggestions } = await response.clone().json();

    if (!suggestions || suggestions.length === 0) {
      addScript();
      return;
    }

    try {
      const suggestedCountry = suggestions[0].parts.country.handle;
      const suggestedLanguage = suggestions[0].parts.language.handle;
      const suggestedCurrency = suggestions[0].parts.currency.handle;

      const selectyData = JSON.parse(
        document.getElementById("__selectors_json").innerText
      );
  
      const currentCountry = selectyData.currentCountry.code;
      const currentLanguage = selectyData.currentLanguage.code;
      const currentCurrency = selectyData.currentCurrency.code;
  
      if (
        suggestedCountry !== currentCountry ||
        suggestedCurrency !== currentCurrency ||
        suggestedLanguage !== currentLanguage
      ) {
        addScript();
      }
    } catch (e) {
      addScript();
    }
  }
})();
